var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 8.8C7.61046 8.8 7.7 8.88954 7.7 9L7.7 14.6C7.7 14.8209 7.87909 15 8.1 15H8.9C9.12091 15 9.3 14.8209 9.3 14.6V9C9.3 8.88954 9.38954 8.8 9.5 8.8H15.1C15.3209 8.8 15.5 8.62091 15.5 8.4V7.6C15.5 7.37909 15.3209 7.2 15.1 7.2H9.5C9.38954 7.2 9.3 7.11046 9.3 7V1.4C9.3 1.17909 9.12091 1 8.9 1H8.1C7.87909 1 7.7 1.17909 7.7 1.4L7.7 7C7.7 7.11046 7.61046 7.2 7.5 7.2H1.9C1.67909 7.2 1.5 7.37909 1.5 7.6V8.4C1.5 8.62091 1.67909 8.8 1.9 8.8H7.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlus);
export default __webpack_public_path__ + "static/media/iconPlus.b59f2b52dc168b588ad8cf3ffccb5ca7.svg";
export { ForwardRef as ReactComponent };